import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from './../../environments/environment';
import {
    FinancialReportBusinesses,
    FinancialReportFilterOptions,
    FinancialReportFilters,
    FinancialReportSummary
} from 'app/models/financial-report';

/**
 * Super User financial report (#158). Node API, admin only.
 * Responses use the `{ success, code, responseData, message }` envelope.
 */
@Injectable({
    providedIn: 'root'
})
export class FinancialReportService {
    private readonly baseUrl = `${environment.apiUrl}financial-report`;

    constructor(private http: HttpClient) { }

    /** `fresh`: skip the API's short-lived cache (refresh button). */
    getSummary(filters: FinancialReportFilters, fresh = false): Observable<FinancialReportSummary> {
        return this.http
            .post<any>(`${this.baseUrl}/summary`, this.body(filters, fresh))
            .pipe(map((res) => res?.responseData));
    }

    getBusinesses(filters: FinancialReportFilters, fresh = false): Observable<FinancialReportBusinesses> {
        return this.http
            .post<any>(`${this.baseUrl}/businesses`, this.body(filters, fresh))
            .pipe(map((res) => res?.responseData));
    }

    private body(filters: FinancialReportFilters, fresh: boolean): any {
        const body: any = this.clean(filters);
        if (fresh) {
            body.refresh = true;
        }
        return body;
    }

    getFilterOptions(): Observable<FinancialReportFilterOptions> {
        return this.http
            .get<any>(`${this.baseUrl}/filters`)
            .pipe(map((res) => res?.responseData));
    }

    /** Drop empty values so the API only receives filters that are set. */
    private clean(filters: FinancialReportFilters): Partial<FinancialReportFilters> {
        const body: any = {};
        Object.keys(filters || {}).forEach((key) => {
            const value = (filters as any)[key];
            if (value !== null && value !== undefined && value !== '') {
                body[key] = value;
            }
        });
        if (body.period !== 'custom') {
            delete body.from;
            delete body.to;
        }
        return body;
    }
}
